export enum DocumentProtectionStatus {
    HIDDEN = "HIDDEN",
    VISIBLE = "VISIBLE",
}
